import type { OfferingModel } from '@sosocio/creator-types/database';

/**
 * Applies the visual filter used to preview embossing and engraving print effects.
 * Unsupported effects deliberately leave the supplied SVG unchanged.
 *
 * @param svgElement SVG root that will be rasterized by the shared renderer.
 * @param printEffect Print treatment configured on the active {@link OfferingModel}.
 */
export function addSvgPrintEffect(
	svgElement: SVGElement,
	printEffect: OfferingModel['printEffect'],
): void {
	if (
		printEffect !== 'embossing'
		&& printEffect !== 'engraving'
		&& printEffect !== 'laser engraving'
	) {
		return;
	}

	const documentModel = svgElement.ownerDocument;

	if (!documentModel) {
		return;
	}

	const filterElement = documentModel.createElementNS(
		'http://www.w3.org/2000/svg',
		'filter',
	);
	const convolutionElement = documentModel.createElementNS(
		'http://www.w3.org/2000/svg',
		'feConvolveMatrix',
	);

	filterElement.id = 'embossing';
	convolutionElement.setAttribute(
		'order',
		'3',
	);
	convolutionElement.setAttribute(
		'kernelMatrix',
		'0 1 3 0 0 0 -3 0 0',
	);
	convolutionElement.setAttribute(
		'divisor',
		'1',
	);
	convolutionElement.setAttribute(
		'bias',
		'0',
	);
	filterElement.appendChild(convolutionElement);
	svgElement.prepend(filterElement);
	svgElement.style.filter = 'url(#embossing)';
}
